export default {
  title: 'Afbeelding slimme prijsregel',
  select: {
    generate_title: 'Genereer een afbeelding met AI',
    generate_subtitle: 'We maken er een op basis van je slimme prijsregel.',
    generate_cta: 'Genereren',
    upload_link: 'of upload van je apparaat',
    rate_limit_company: {
      title: 'We hebben even een moment nodig',
      description: 'Jouw restaurant heeft dit uur veel afbeeldingen gegenereerd. Probeer het opnieuw over {{time}}.',
    },
    rate_limit_smart_pricing_rule: {
      title: 'Even op adem komen',
      description: 'Je hebt deze regel een paar keer achter elkaar geprobeerd. We zijn over {{time}} weer klaar.',
    },
  },
  generating: {
    title: 'Je afbeelding genereren…',
    progress: {
      cooking: 'Iets lekkers aan het bereiden…',
      plating: 'Aanrichten…',
      finishing: 'De laatste hand leggen…',
    },
  },
  preview: {
    alt: 'Gegenereerde afbeelding slimme prijsregel',
    hint: 'Niet helemaal goed? Opnieuw genereren, of doorgaan om de afbeelding bij te snijden.',
    click_to_expand: 'Klik om te vergroten',
    regenerate: 'Opnieuw genereren',
    continue: 'Doorgaan naar bewerken',
  },
  toasts: {
    upload_success: 'Afbeelding succesvol geüpload.',
    upload_failed: 'Uploaden van afbeelding mislukt.',
    delete_success: 'Afbeelding succesvol verwijderd.',
    delete_failed: 'Verwijderen van afbeelding mislukt.',
    generate_success: 'Afbeelding succesvol gegenereerd.',
    generate_failed: 'Starten van afbeeldingsgeneratie mislukt.',
    generate_timeout: 'De afbeelding wordt nog gegenereerd. Ze verschijnt hier zodra ze klaar is.',
    rate_limit_company: 'Uurlimiet voor afbeeldingen bereikt voor dit restaurant. Probeer het opnieuw over {{time}}.',
    rate_limit_smart_pricing_rule: 'Te veel pogingen voor deze regel zojuist — probeer het opnieuw over {{time}}.',
  },
  time: {
    seconds_one: '1 seconde',
    seconds_other: '{{count}} seconden',
    minutes_one: '1 minuut',
    minutes_other: '{{count}} minuten',
    hours_one: '1 uur',
    hours_other: '{{count}} uur',
  },
};
